import { Button, Divider } from '@aon/aon-tws-common-ui';
import * as React from 'react';
import styled from 'styled-components';
import ContentConstants from '../../../contentConstants';
import { IBenchmark, ISurveyAdminSummary } from '../../../models';
import { SurveyStatusType } from '../../../models/SurveyStatusType';
import { BenchmarkSelector } from '../../benchmarks/BenchmarkSelector';
import { CardLayout, LabelAbove } from '../../common';
import { RightButtonContainer } from '../../common/styles/globalStyles';

const BenchmarkSelectorContainer = styled.div`
	min-height: 390px;
`;

export interface IAdminBenchmarksProps {
	surveyId: number;
	availableBenchmarks: IBenchmark[];
	benchmarkIds: number[];
	benchmarksLoading: boolean;
	surveyBenchmarksLoading: boolean;
	surveyBenchmarksSaving: boolean;
	globalTopQuartileId?: number;
	GetBenchmarksIfNeeded: () => void;
	GetSurveyBenchmarks: (surveyId: number) => void;
	SaveSurveyBenchmarks: (surveyId: number, benchmarkIds: number[]) => void;
	ShowInfoNotification: (message: string) => void;
	GetMissingBenchmarks: (missingIds: number[]) => void;
	GetGlobalTopQuartileId: () => void;
	surveyAdminSummary?: ISurveyAdminSummary;
}

export interface IAdminBenchmarksState {
	selectedBenchmarkIds: number[];
}

export class AdminBenchmarks extends React.PureComponent<IAdminBenchmarksProps, IAdminBenchmarksState> {
	constructor(props: IAdminBenchmarksProps) {
		super(props);

		this.state = {
			selectedBenchmarkIds: props.benchmarkIds,
		};

		this.UpdateSelectedBenchmarks = this.UpdateSelectedBenchmarks.bind(this);
		this.AddBenchmark = this.AddBenchmark.bind(this);
		this.RemoveBenchmark = this.RemoveBenchmark.bind(this);
	}

	public UNSAFE_componentWillMount() {
		this.props.GetBenchmarksIfNeeded();
		this.props.GetSurveyBenchmarks(this.props.surveyId);
		this.props.GetGlobalTopQuartileId();
	}

	public UNSAFE_componentWillReceiveProps(nextProps: IAdminBenchmarksProps) {
		if (this.props.benchmarkIds !== nextProps.benchmarkIds) {
			this.UpdateSelectedBenchmarks(nextProps.benchmarkIds);
		}
	}

	public UpdateSelectedBenchmarks(selectedBenchmarkIds: number[]) {
		if (this.state.selectedBenchmarkIds.length > selectedBenchmarkIds.length) {
			this.props.ShowInfoNotification(ContentConstants.TOAST_BENCHMARKMODAL_REMOVED);
		}
		this.setState({ selectedBenchmarkIds });
	}

	public AddBenchmark(benchmarkId: number) {
		this.setState({ selectedBenchmarkIds: this.state.selectedBenchmarkIds.concat(benchmarkId) });
		this.props.ShowInfoNotification(ContentConstants.TOAST_BENCHMARKMODAL_ADDED);
	}

	public RemoveBenchmark(benchmarkId: number) {
		this.setState({ selectedBenchmarkIds: this.state.selectedBenchmarkIds.filter((b) => b !== benchmarkId) });
		this.props.ShowInfoNotification(ContentConstants.TOAST_BENCHMARKMODAL_REMOVED);
	}

	public render() {
		const { globalTopQuartileId, surveyAdminSummary } = this.props;
		const readOnly = surveyAdminSummary ? surveyAdminSummary.surveyStatus === SurveyStatusType.Cancelled : false;
		return (
			<CardLayout
				loading={this.props.benchmarksLoading || this.props.surveyBenchmarksLoading}
				title={
					readOnly
						? ContentConstants.SURVEY_ADMIN_ACTION_ADD_SUBTRACT_BENCHMARKS_READONLY
						: ContentConstants.SURVEY_ADMIN_ACTION_ADD_SUBTRACT_BENCHMARKS
				}
			>
				{readOnly && <LabelAbove type='input' textIsHtml={true} text={ContentConstants.SURVEY_CANCEL_CONTENT_READONLY} />}
				<BenchmarkSelectorContainer>
					<BenchmarkSelector
						globalTopQuartileId={globalTopQuartileId}
						readOnly={readOnly}
						availableBenchmarks={this.props.availableBenchmarks}
						selectedBenchmarkIds={this.state.selectedBenchmarkIds}
						descriptionText={!readOnly ? ContentConstants.SURVEY_ADMIN_BENCHMARKS_DESCRIPTION : ''}
						UpdateSelectedBenchmarks={this.UpdateSelectedBenchmarks}
						AddBenchmark={this.AddBenchmark}
						RemoveBenchmark={this.RemoveBenchmark}
						GetMissingBenchmarks={this.props.GetMissingBenchmarks}
					/>
				</BenchmarkSelectorContainer>
				<Divider type='dashed' />
				{!readOnly && (
					<RightButtonContainer>
						<Button
							id='SaveButton'
							color='primary'
							size='lg'
							disabled={this.props.surveyBenchmarksSaving}
							onClick={() => this.props.SaveSurveyBenchmarks(this.props.surveyId, this.state.selectedBenchmarkIds)}
						>
							{ContentConstants.BUTTON_SAVE_CHANGES}
						</Button>
					</RightButtonContainer>
				)}
			</CardLayout>
		);
	}
}
